import type { ReactElement } from 'react';
import useCheckPermissions from '@/hooks/util/useCheckPermissions';
import type { Permissions } from '@/Interfaces/Data';
import type { DotNestedKeys } from '@/_types/utils';

interface AccessPermissionProps {
  permissionKey: DotNestedKeys<Permissions>[] | DotNestedKeys<Permissions>;
  noRender?: ReactElement | null;
  children: ReactElement;
}

export function AccessPermission({
  permissionKey,
  noRender = null,
  children,
}: AccessPermissionProps) {
  const permissionCheck = Array.isArray(permissionKey)
    ? permissionKey
    : [permissionKey];
  return useCheckPermissions(...permissionCheck) ? children : noRender;
}
